<script lang="ts">
    import {ExclamationCircleOutline} from "flowbite-svelte-icons";
    import {Tooltip} from "flowbite-svelte";

    export let complete:boolean;
</script>
{#if !complete}
    <ExclamationCircleOutline class="w-8 h-8 text-red-500"/>
    <Tooltip>Unvollständige Daten</Tooltip>
{/if}